import styled from 'styled-components/macro';
import images from '~/constants/images';
import { Button } from '~/components';

export const Form = styled.form`
  display: ${({ flex }) => (flex ? 'flex' : 'grid')};
  ${({ columns }) => (columns === 2 ? `grid-template-columns: 50% 50%;` : ``)}
  grid-column-gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || 100}%;
  border: 10px solid ${({ theme }) => theme.blue};
  padding: 20px 60px;
  background-color: ${({ theme }) => theme.light};
`;

export const FormHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: auto;
`;

export const Logo = styled.div`
  width: 100%;
  height: 80px;
  background-image: url(${images.logoBlackHorizontal});
  background-size: 170px;
  background-repeat: no-repeat;
  background-position: center;
`;

export const FormTitle = styled.p`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.h5}px;
  width: 100%;
  text-align: center;
  margin: 10px 0;
`;

export const DeleteLogoButton = styled(Button)`
  width: 304px;
  height: 40px;
  border-style: none;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.gray : theme.dark};
  color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.white)};
  transition: color 0.3s, background-color 0.3s;
  margin: 0 0 10px;
`;

export const SubmitButton = styled(Button)`
  width: 304px;
  height: 40px;
  border-style: none;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.gray : theme.dark};
  color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.white)};
  transition: color 0.3s, background-color 0.3s;
  margin: 0 0 10px;
`;

export const CancelButton = styled(Button)`
  width: 304px;
  height: 40px;
  border-style: none;
  background-color: transparent;
  color: ${({ theme, disabled }) => (disabled ? theme.gray2 : theme.white)};
  transition: color 0.3s, background-color 0.3s;
  margin: 0 0 10px;
`;

export const Advice = styled.p`
  width: 100%;
  text-align: center;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  margin-bottom: 10px;
`;

export const Return = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SmallNotification = styled.p`
  width: 100%;
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.label}px;
  color: ${({ theme }) => theme.dark2};
  margin: 0 0 10px;
`;
